export default {
  install: function (Vue) {
    Vue.prototype.$clone = input => JSON.parse(JSON.stringify(input))
    Vue.prototype.$ensure2 = input => (Number(input) < 10 ? '0' : '') + input
    Vue.prototype.$dig = (start, fields) => fields.reduce((prev, field) => prev ? prev[field] : prev, start)
  },
}